/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebContent {
    "use strict";

    export class LoginController {
        public static $inject : string[] = ['CurrentUser','$state','$location','$mdDialog'];

        constructor(public CurrentUser : any,public $state : any,public $location : any,public $mdDialog : any) {}

        public loginSuccess() : void {

            var that = this;

            // This affects only admin-created and manually confirmed users' first login.
            //
            if (this.CurrentUser.user.data.sign_in_count === 1) {

                this.$mdDialog.show({
                    templateUrl: '/content/settings/account_activation_success.html',
                    controller: ( $scope: any, $mdDialog: any ) => {
                        $scope.close = function() {
                            $mdDialog.hide();
                        }
                    },
                    parent: angular.element(document.body),
                    multiple: true,
                    clickOutsideToClose: true
                });
            }

            this.$state.go('shortcuts.chooseLocation',{afterLogin: true});
        }
    }

    getDealerwareWebContentModule().controller('LoginController', LoginController);
}
